import { DateTime } from 'luxon';

export const endDateStringToJS = (endDate: string, timeZone: string) => {
  const endDateJS = DateTime.fromISO(endDate, {
    zone: timeZone,
  })
    .endOf('day')
    .toJSDate();
  return endDateJS;
};

export const startDateStringToJS = (startDate: string, timeZone: string) => {
  const startDateJS = DateTime.fromISO(startDate, {
    zone: timeZone,
  })
    .startOf('day')
    .toJSDate();
  return startDateJS;
};
